import { ethers } from 'ethers'
import { useState, useEffect, useMemo, useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { addresses } from 'src/constants';
import { IJsonRPCError } from 'src/slices/interfaces';
import { clearPendingTxn, fetchPendingTxns } from 'src/slices/PendingTxnsSlice';
import { useWeb3Context } from '.';
import { abi as MigrateICY } from "../abi/MigrateICY.json";
import { error } from "../slices/MessagesSlice";
import imageURL from '../assets/tokens/coin.png'
import { abi as ierc20Abi } from "../abi/IERC20.json";
export default function useMigrate() {

    const dispatch = useDispatch()
    const [glaBalance, setGlaBalance] = useState('0')
    const [iceBalance, setIceBalance] = useState('0')
    const [icyBalance, setIcyBalance] = useState('0')
    const { address, provider, chainID } = useWeb3Context()
    const [ApprovedGla, setApprovdGla] = useState(false)
    const [ApprovedIce, setApprovdIce] = useState(false)
    useEffect(() => {
        initData().then()
    }, [address, provider, chainID])

    const initData = useCallback(
        async () => {
            if (provider && chainID && address) {
                try {
                    const glaContract = new ethers.Contract(addresses[chainID].GLA_ADDRESS, ierc20Abi, provider)
                    const glaBalance = await glaContract.balanceOf(address)
                    const tokendecimals = await glaContract.decimals()
                    setGlaBalance(ethers.utils.formatUnits(glaBalance, tokendecimals))

                    const iceContract = new ethers.Contract(addresses[chainID].OLD_ICE_ADDRESS, ierc20Abi, provider)
                    const token1decimals = await iceContract.decimals()
                    const iceBalance = await iceContract.balanceOf(address)
                    setIceBalance(ethers.utils.formatUnits(iceBalance, token1decimals))

                    const icyContract = new ethers.Contract(addresses[chainID].OHM_ADDRESS, ierc20Abi, provider)
                    const token2decimals = await icyContract.decimals()
                    const icyBalance = await icyContract.balanceOf(address)
                    setIcyBalance(ethers.utils.formatUnits(icyBalance, token2decimals))

                    const ApprovedGla = await glaContract.allowance(address, addresses[chainID].ICY_MIGRATION_ADDRESS)
                    setApprovdGla(ApprovedGla > 0)

                    const ApprovedIce = await iceContract.allowance(address, addresses[chainID].ICY_MIGRATION_ADDRESS)
                    setApprovdIce(ApprovedIce > 0)
                } catch (error) {
                    console.log(error)
                }
            }
        },
        [address, provider, chainID])

    const addTokenToWallet = async () => {
        if (window.ethereum) {
            try {
                await window.ethereum.request({
                    method: "wallet_watchAsset",
                    params: {
                        type: "ERC20",
                        options: {
                            address: addresses[chainID].OHM_ADDRESS,
                            symbol: 'ZENVO',
                            decimals: 9,
                            image: imageURL,
                        },
                    },
                });
            } catch (e: unknown) {
                const rpcError = e as IJsonRPCError;
                rpcError.data ? dispatch(error(rpcError.data.message)) : dispatch(error(rpcError.message))
            }
        }
    }

    const DoApprove = useCallback(
        async (tokenAddress: string) => {
            if (address && provider && chainID) {
                const signer = provider.getSigner()
                const asohContract = new ethers.Contract(tokenAddress, ierc20Abi, signer)
                let tx;
                try {
                    tx = await asohContract.approve(
                        addresses[chainID].ICY_MIGRATION_ADDRESS,
                        ethers.utils.parseUnits("1000000000", "ether").toString()
                    )
                    dispatch(
                        fetchPendingTxns({ txnHash: tx.hash, text: "Approve", type: "Approve_ICE" })
                    );
                    await tx.wait()
                    return tx
                } catch (e: unknown) {
                    const rpcError = e as IJsonRPCError;
                    rpcError.data ? dispatch(error(rpcError.data.message)) : dispatch(error(rpcError.message))
                } finally {
                    if (tx) {
                        initData().then()
                        dispatch(clearPendingTxn(tx.hash));
                    }
                }
            }
        },
        [address, provider, chainID],
    )
    const handlerMigrate = useCallback(async () => {
        let tx;	// Migrate
        try {
            const signer = provider.getSigner();
            const migrationContract = new ethers.Contract(addresses[chainID].ICY_MIGRATION_ADDRESS, MigrateICY, signer)
            tx = await migrationContract.migrate()
            dispatch(
                fetchPendingTxns({ txnHash: tx.hash, text: "Claim", type: "Claim_ICE" }),
            );
            await tx.wait();
            return tx
        } catch (e: unknown) {
            const rpcError = e as IJsonRPCError;
            rpcError.data ? dispatch(error(rpcError.data.message)) : dispatch(error(rpcError.message))
        } finally {
            if (tx) {
                initData().then()
                await addTokenToWallet()
                dispatch(clearPendingTxn(tx.hash));
            }
        }
    }, [address, provider, chainID])

    return { glaBalance, iceBalance, icyBalance, ApprovedGla, ApprovedIce, DoApprove, handlerMigrate }
}

